/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Twitterdescription1Inputs */

const ja_metadata_twitterdescription1 = /** @type {(inputs: Metadata_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINは、ゲームマーケティングやインフルエンサーマーケティング、ゲーム関連のWebプロダクトやECサービスの開発・運営を行っています。また、eスポーツイベントの制作・運営も主要な事業として展開しています。`)
};

const en_metadata_twitterdescription1 = /** @type {(inputs: Metadata_Twitterdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN engages in game marketing, influencer marketing, and the development and operation of game-related web products and e-commerce services. Additionally, the production and management of esports events are also major aspects of our business.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN engages in game marketing, influencer marketing, and the development and operation of game-related web products and e-commerce services. Additional..." |
*
* @param {Metadata_Twitterdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_twitterdescription1 = /** @type {((inputs?: Metadata_Twitterdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Twitterdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_twitterdescription1(inputs)
	return en_metadata_twitterdescription1(inputs)
});
export { metadata_twitterdescription1 as "metadata_twitterDescription" }